/* eslint-disable no-unused-vars */

import { ts } from '_core';

export enum RISK_METRIC_ENUM {
  TOTAL = 'PCR',
  FACTOR = 'FPCR',
  SPECIFIC = 'SPCR',
}
export enum FRACTIONAL_RISK_ENUM {
  FRACTION = 'fractional risk',
  RISK = 'risk',
}

export enum VARIABLES_FILTER_ENUM {
  NONE = 'NONE',
  ALPHAS = 'ALPHAS',
  HOLDINGS = 'HOLDINGS',
}

export type JobParams = {
  histories: '$context_histories' | ts.enums.HISTORY_ENUM_EXTENDED[];
  attribution_type: 'holdings' | 'returns' | 'risk';
  buckets: ts.types.widgets.common.BucketValue;
  variables: ts.types.widgets.common.ExplanatoryVariablesValue;
  variable_filter: VARIABLES_FILTER_ENUM;
  intercept: boolean;
  without_residuals: boolean;
  include_benchmark: boolean;
  benchmark_neutral: boolean;
};

export type Params = JobParams;
export type DraftParams = Partial<Params>;
